<template>
  <v-form ref="contactEditForm" v-model="valid" class="contact-page">
    <v-row>
      <v-col cols="12">
        <h1>О нас</h1>
      </v-col>

      <v-col cols="12">
        <v-tabs v-model="tab">
          <v-tab>Хедер</v-tab>
          <v-tab>Блоки</v-tab>
          <v-tab>Футер</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-6">
          <v-tab-item :eager="true">
            <v-row>
            <v-col cols="12" sm="5" md="4" xl="3">
            <v-img :src="previewImage(true, headerImage)" width="246" height="195" class="mb-8">
              <template v-slot:placeholder>
                <div class="image-placeholder"></div>
              </template>
            </v-img>
            <v-file-input label="Картинка"
                          prepend-icon=""
                          class="cursor-pointer"
                          outlined
                          placeholder="1902х1508.jpg"
                          append-icon="mdi-attachment"
                          v-model="headerImage">
            </v-file-input>
            <v-tabs v-model="tabLang" class="pb-2">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-text-field
                    v-model="page.header.title"
                    label="Заголовок"
                    outlined
                ></v-text-field>
                <v-textarea
                    v-model="page.header.description"
                    label="Описание"
                    outlined
                ></v-textarea>
                <v-text-field
                    v-model="page.header.title_1"
                    label="Заголовок 2"
                    outlined
                ></v-text-field>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-text-field
                    v-model="page.header.title_ua"
                    label="Заголовок"
                    outlined
                ></v-text-field>
                <v-textarea
                    v-model="page.header.description_ua"
                    label="Описание"
                    outlined
                ></v-textarea>
                <v-text-field
                    v-model="page.header.title_1_ua"
                    label="Заголовок 2"
                    outlined
                ></v-text-field>
              </v-tab-item>
            </v-tabs-items>
            </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col cols="12" sm="12" md="6" xl="6">
                <div v-if="page.blocks" v-for="(block, index) in page.blocks" >
                  <div class="text"><span>Блок {{ index + 1}}</span><div class="remove" @click="submitDialog = true; submitItem = block"><v-icon>mdi-close</v-icon></div></div>
                <div class="block" :class="{reverse: block.is_reverse}">
                  <div class="left">
                    <v-img :src="block.image_url" width="246" height="195" class="mb-8">
                      <template v-slot:placeholder>
                        <div class="image-placeholder"></div>
                      </template>
                    </v-img>
                    <v-file-input label="Картинка"
                                  prepend-icon=""
                                  class="cursor-pointer"
                                  outlined
                                  @change="appendImage(block)"
                                  placeholder="1902х1508.jpg"
                                  append-icon="mdi-attachment"
                                  hide-details
                                  v-model="block.image_file">
                    </v-file-input>
                  </div>
                  <div class="reverse" @click="block.is_reverse = !block.is_reverse"><v-icon large>mdi-swap-horizontal</v-icon></div>
                  <div class="right">
                    <v-tabs v-model="block.tab" class="pb-2">
                      <v-tab>RU</v-tab>
                      <v-tab>UA</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="block.tab">
                      <v-tab-item :eager="true">
                        <v-text-field
                            v-model="block.title"
                            label="Заголовок"
                            outlined
                        ></v-text-field>
                        <v-textarea
                            v-model="block.description"
                            label="Описание"
                            outlined
                            hide-details
                        ></v-textarea>

                      </v-tab-item>
                      <v-tab-item :eager="true">
                        <v-text-field
                            v-model="block.title_ua"
                            label="Заголовок"
                            outlined
                        ></v-text-field>
                        <v-textarea
                            v-model="block.description_ua"
                            label="Описание"
                            outlined
                            hide-details
                        ></v-textarea>
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </div>
                </div>
                <div class="text-right">
                  <v-btn outlined @click="addBlock">Добавить блок</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
            <v-col cols="12" sm="5" md="4" xl="3">
            <v-img :src="previewImage(false, footerImage)" width="246" height="195" class="mb-8">
              <template v-slot:placeholder>
                <div class="image-placeholder"></div>
              </template>
            </v-img>
            <v-file-input label="Картинка"
                          prepend-icon=""
                          class="cursor-pointer"
                          outlined
                          placeholder="1902х1508.jpg"
                          append-icon="mdi-attachment"
                          v-model="footerImage">
            </v-file-input>
            <v-tabs v-model="tabLang" class="pb-2">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-textarea
                    v-model="page.footer.description"
                    label="Описание"
                    outlined
                ></v-textarea>
                <v-text-field
                    v-model="page.footer.button"
                    label="Имя кнопки"
                    outlined
                ></v-text-field>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-textarea
                    v-model="page.footer.description_ua"
                    label="Описание"
                    outlined
                ></v-textarea>
                <v-text-field
                    v-model="page.footer.button_ua"
                    label="Имя кнопки"
                    outlined
                ></v-text-field>
              </v-tab-item>
            </v-tabs-items>
            <v-text-field
                v-model="page.footer.button_url"
                label="Ссылка"
                outlined
            ></v-text-field>
            </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-btn @click="update">Сохранить</v-btn>
      </v-col>
      <v-dialog
          v-model="submitDialog"
          max-width="444"
      >
        <v-card>
          <v-card-title >
            Подтвердить действие
          </v-card-title>

          <v-card-actions>


            <v-btn
                v-if="submitItem == null"
                @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                v-else
                @click="submitDelete(submitItem); submitDialog = false">
              Да
            </v-btn>
            <v-btn
                outlined
                @click="submitDialog = false"
            >
              Нет
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import PageService from './../../api/PageService'

export default {
  name: 'Info',
  props: {},
  components: {},
  data: () => ({
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    submitDialog: false,
    submitItem: null,
    snackbarColor: '',
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    valid: true,
    tab: '',
    tabLang: '',
    block: {
      tab: 0,
      image: '',
      image_url: '',
      is_reverse: false,
      title: '',
      title_ua: '',
      description: '',
      description_ua: '',
      image_file: null,
    },
    page: {
      blocks: [],
      header: {
        title: '',
        title_1: '',
        description: '',
        title_ua: '',
        title_1_ua: '',
        description_ua: '',
        image: null,
        image_url: null
      },
      footer: {
        button: '',
        description: '',
        button_ua: '',
        button_url: '',
        description_ua: '',
        image: null,
        image_url: null
      },
    },
    headerImage: null,
    footerImage: null,
    loading: true,
    loadingButton: false,
  }),
  mounted() {
    PageService.getInfo()
        .then(response => {
          this.page = response.data;

          this.page.blocks.forEach(function (item) {
            if(item.image_url !== ''){
              item.image_file = {}
              item.image_file.url = item.image_url;
              item.image_file.name = item.image
            }
          })

          if (this.page.header.image) {
            this.headerImage = {}
            this.headerImage.url = this.page.header.image_url;
            this.headerImage.name = this.page.header.image
          }

          if (this.page.footer.image) {
            this.footerImage = {}
            this.footerImage.url = this.page.footer.image_url;
            this.footerImage.name = this.page.footer.image
          }

          this.loading = false
        });
  },
  methods: {
    submitDelete(block){
      this.page.blocks.splice(this.page.blocks.indexOf(block) , 1)
    },
    addBlock(){
        if(this.page.blocks === undefined || !this.page.blocks){
          this.page.blocks = []
        }

        this.page.blocks.push(Object.assign({}, this.block))
    },
    validate() {


    },
    appendImage(block){
      block.image_url = URL.createObjectURL(block.image_file)
    },
    previewImageBlock(imageFile) {
      if (imageFile) {
        return URL.createObjectURL(imageFile)
      }
    },
    previewImage(isHeader, image) {
      if (isHeader) {
        if (this.headerImage && this.headerImage.url) {
          return this.headerImage.url
        }
      } else {
        if (this.footerImage && this.footerImage.url) {
          return this.footerImage.url
        }
      }

      if (image) {
        return URL.createObjectURL(image)
      }
    },
    update() {

      this.loadingButton = true;
      let formData = this.getData();

      PageService.updateInfo(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Страница успешно обновлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении страницы';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      let formData = new FormData();

      formData.append('header[title]', this.page.header.title);
      formData.append('header[title_1]', this.page.header.title_1);
      formData.append('header[description]', this.page.header.description);
      formData.append('header[title_ua]', this.page.header.title_ua);
      formData.append('header[title_1_ua]', this.page.header.title_1_ua);
      formData.append('header[description_ua]', this.page.header.description_ua);
      formData.append('header[image_url]', this.page.header.image_url);
      formData.append('header[image]', this.page.header.image);

      formData.append('footer[button_url]', this.page.footer.button_url);
      formData.append('footer[button]', this.page.footer.button);
      formData.append('footer[description]', this.page.footer.description);
      formData.append('footer[button_ua]', this.page.footer.button_ua);
      formData.append('footer[description_ua]', this.page.footer.description_ua);
      formData.append('footer[image_url]', this.page.footer.image_url);
      formData.append('footer[image]', this.page.footer.image);

      this.page.blocks.forEach(function (item, index) {
        formData.append(`blocks[${index}][title]`, item.title);
        formData.append(`blocks[${index}][title_ua]`, item.title_ua);
        formData.append(`blocks[${index}][description]`, item.description);
        formData.append(`blocks[${index}][description_ua]`, item.description_ua);
        formData.append(`blocks[${index}][image]`, item.image);
        formData.append(`blocks[${index}][image_url]`, item.image_url);
        formData.append(`blocks[${index}][is_reverse]`, item.is_reverse);

        if(item.image_file && !item.image_file.url) {
          formData.append(`blocks[${index}][image_file]`, item.image_file);
        }
      })

      if (this.headerImage && !this.headerImage.url) {
        formData.append('headerImage', this.headerImage);
      }

      if (this.footerImage && !this.footerImage.url) {
        formData.append('footerImage', this.footerImage);
      }

      return formData;
    }
  },
}
</script>

<style lang="scss">
.contact-page {
  .v-input__append-inner {
    margin-top: 13px !important;
  }
}
</style>

<style scoped lang="scss">
.text{
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #5D6670;
  display: flex;
  justify-content: space-between;
  .remove{
    &:hover{
      .v-icon{
        color: red;
        cursor: pointer;
      }
    }
  }
}
.block{
  display: grid;
  grid-template-columns: 31% 6% 48%;
  grid-column-gap: 7.5%;
  border-bottom: 1px solid #E0E8F0;
  padding-bottom: 32px;
  margin-bottom: 32px;



  .reverse{
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  &.reverse{
    grid-template-columns: 48% 6% 31%;
    .left{
      order: 3;
    }
    .right{
      order: 1;
    }
    .reverse{
      order: 2;
    }
  }
}
.image-placeholder {
  width: 100%;
  height: 100%;
  background-color: #F3F7FC;
  border-radius: 4px;
}

.contact-images .v-image {
  max-height: 374px;
}

.mobile {
  width: 300px;
  height: 300px;
  margin-bottom: 24px;
}

.contact {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: 3px;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>
